import PropTypes from 'prop-types';
import Modal from 'components/templates/Modal/Modal';
import * as ALOOMA from 'consts/alooma';
import Alooma from 'services/alooma';
import ModalBodyKarmaEarnRedirectError from 'components/molecules/ModalBodyKarmaEarnRedirectError/ModalBodyKarmaEarnRedirectError';

const ModalKarmaEarnRedirectError = props => {
  const { closeModal, sourcePage, item } = props;

  return (
    <Alooma.GameIdContext.Provider value={item.id}>
      <Modal
        source={sourcePage}
        onClose={closeModal}
        aloomaModalName={ALOOMA.MODAL_NAMES.KARMA_EARN_REDIRECT_ERROR}
        aloomaModalType={ALOOMA.MODAL_TYPES.POPUP}
        sendPageView={false}
      >
        <ModalBodyKarmaEarnRedirectError {...props} />
      </Modal>
    </Alooma.GameIdContext.Provider>
  );
};

ModalKarmaEarnRedirectError.propTypes = {
  closeModal: PropTypes.func.isRequired,
  sourcePage: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired,
};

export default ModalKarmaEarnRedirectError;
